
import React from "react";
import { Box, Collapse } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { localizeDateTimeShort } from "utils/dateFormats";

export const NoteReplyItem = ({ reply }) => {
  
  return (
    <Box>
      <Box>
        <div className="reply-item ml-[80px] mt-5 p-3">
          <p className="text-[12px] text-gray-500">
            {reply?.user?.name}
            <FiberManualRecord
              style={{
                color: "gray",
                marginLeft: "5px",
                marginRight: "5px",
                fontSize: 5,
              }}
            />
            <span className="text-[10px] text-gray-400">
              {localizeDateTimeShort(reply?.createdAt)}
              {reply?.createdAt !== reply?.updatedAt && (
                <>
                  <FiberManualRecord
                    style={{
                      color: "gray",
                      marginLeft: "5px",
                      marginRight: "5px",
                      fontSize: 5,
                    }}
                  />
                  Edited
                </>
              )}
            </span>
          </p>
          <Collapse in>
            <p className="mt-2">{reply.replyText}</p>
          </Collapse>
        </div>
      </Box>
    </Box>
  );
};
 